import React from "react";


import {

    Document,

    Page,

    Text,

    View,

    Image,

    StyleSheet

} from "@react-pdf/renderer";



import schoolLogo from "./zpa.png";




/*
==========================================================
COLORS
==========================================================
*/


const COLORS = {


    black:
        "#09090b",


    deepGray:
        "#18181b",


    gray:
        "#6b7280",


    lightGray:
        "#f3f4f6",


    orange:
        "#f97316",


    deepOrange:
        "#ea580c",


    chameleon:
        "#84cc16",


    white:
        "#ffffff",


    border:
        "#d1d5db"


};






/*
==========================================================
PDF STYLES
==========================================================
*/


const styles = StyleSheet.create({


page:{


    padding:30,


    fontSize:9,


    fontFamily:"Helvetica",


    backgroundColor:
        COLORS.white


},






/*
------------------------------
SCHOOL HEADER
------------------------------
*/


header:{


    flexDirection:"row",


    alignItems:"center",


    justifyContent:"space-between",


  backgroundColor:
    "#b9c0c8",


    padding:15,


    borderRadius:8,


    marginBottom:15



},




logo:{


    width:75,


    height:75,


    objectFit:"contain",


    borderRadius:8



},





schoolInformation:{


    flex:1,


    marginLeft:15,


    justifyContent:"center"


},




schoolName:{


    fontSize:20,


    fontWeight:"bold",


    color:
        COLORS.black,


    marginBottom:5


},




schoolAddress:{


    fontSize:9,


    color:
        COLORS.black,


    marginBottom:4


},




schoolContact:{


    fontSize:9,


    color:
        "#000000"


},





reportBadge:{


    width:130,


    padding:10,


    backgroundColor:
        COLORS.deepOrange,


    borderRadius:8,


    alignItems:"center"


},





badgeTitle:{


    color:
        COLORS.white,


    fontSize:10,


    fontWeight:"bold",


    marginBottom:5


},




badgeText:{


    color:
        COLORS.white,


    fontSize:8,


    textAlign:"center"


},







/*
------------------------------
INFORMATION BOX
------------------------------
*/


infoBox:{


    backgroundColor:
        COLORS.lightGray,


    padding:12,


    borderRadius:6,


    marginBottom:15



},





row:{


    flexDirection:"row",


    justifyContent:"space-between",


    marginBottom:6


},







/*
------------------------------
SUMMARY
------------------------------
*/


summaryContainer:{


    flexDirection:"row",


    justifyContent:"space-between",


    marginBottom:15


},





summaryCard:{


    width:"30%",


    padding:12,


    borderWidth:1,


    borderColor:
        COLORS.border,


    borderRadius:6,


    backgroundColor:
        COLORS.white


},





summaryTitle:{


    fontSize:8,


    color:
        COLORS.gray


},





summaryValue:{


    marginTop:6,


    fontSize:13,


    fontWeight:"bold",


    color:
        COLORS.deepOrange


},






/*
------------------------------
TABLE
------------------------------
*/


table:{


    width:"100%",


    borderWidth:1,


    borderColor:
        COLORS.border


},





tableHeader:{


    flexDirection:"row",


    backgroundColor:
        COLORS.black,


    color:
        COLORS.white,


    padding:6


},





tableRow:{


    flexDirection:"row",


    borderBottomWidth:1,


    borderColor:
        COLORS.border,


    paddingVertical:6


},





cell:{


    paddingHorizontal:4,


    fontSize:8


},





idCell:{


    width:"5%"


},



studentCell:{


    width:"16%"


},




feeCell:{


    width:"18%"


},




categoryCell:{


    width:"12%"


},




amountCell:{


    width:"10%"


},




balanceCell:{


    width:"10%"


},




payerCell:{


    width:"12%"


},




createdCell:{


    width:"10%"


},




dateCell:{


    width:"10%"


},






/*
------------------------------
FOOTER
------------------------------
*/


footer:{


    position:"absolute",


    bottom:20,


    left:30,


    right:30,


    textAlign:"center",


    fontSize:8,


    color:
        COLORS.gray


}



});









/*
==========================================================
COMPONENT
==========================================================
*/


const DailyPaymentTransactionPDF = ({

    transactions=[],

    title,


    studentReport=false,


    studentName


}) => {







/*
==========================================================
CALCULATIONS
==========================================================
*/


const totalPaid =


transactions.reduce(


    (sum,item)=>


        sum +

        Number(

            item.amount_paid || 0

        ),


    0


);







const totalBalance =


transactions.reduce(


    (sum,item)=>


        sum +

        Number(

            item.balance || 0

        ),


    0


);









return (


<Document>





<Page


    size="A4"


    orientation="landscape"


    style={styles.page}


>









{/*

==========================================================
PROFESSIONAL SCHOOL HEADER
==========================================================

*/}



<View


style={styles.header}


>




<Image


src={schoolLogo}


style={styles.logo}


/>







<View


style={styles.schoolInformation}


>



<Text
style={styles.schoolName}>
Excellent Kids Foundation
</Text>




<Text
style={styles.schoolAddress}>
GreenLand Commnity, Upper Johnsonville TownShip - Left Bank 2B, Montserrade County, Liberia
</Text>




<Text


style={styles.schoolContact}

>

Tel: +231 XXX XXX XXX

{"   "}

Email: info@school.com

</Text>



</View>







<View


style={styles.reportBadge}


>



<Text


style={styles.badgeTitle}


>

PAYMENT REPORT

</Text>




<Text


style={styles.badgeText}


>


{

studentReport

?

`${studentName || ""} Payment History`

:

title

}



</Text>



</View>





</View>









{/*

==========================================================
REPORT INFORMATION
==========================================================

*/}




<View


style={styles.infoBox}


>



<View


style={styles.row}


>



<Text>

Report Type:

</Text>



<Text>


{

studentReport

?

"Individual Student Payment Record"

:

"Daily Transaction Record"

}



</Text>



</View>







<View


style={styles.row}

>


<Text>

Generated Date:

</Text>




<Text>

{

new Date()

.toLocaleDateString()

}

</Text>


</View>







{

studentReport && (



<View


style={styles.row}


>


<Text>

Student:

</Text>



<Text>

{studentName}

</Text>



</View>



)


}




</View>









{/*

==========================================================
SUMMARY SECTION
==========================================================

*/}





<View


style={styles.summaryContainer}


>




<View


style={styles.summaryCard}


>



<Text


style={styles.summaryTitle}


>

Total Transactions

</Text>



<Text


style={styles.summaryValue}


>

{

transactions.length

}

</Text>



</View>







<View


style={styles.summaryCard}


>



<Text


style={styles.summaryTitle}


>

Total Paid

</Text>



<Text


style={styles.summaryValue}


>

$

{

totalPaid.toFixed(2)

}

</Text>



</View>







<View


style={styles.summaryCard}


>



<Text


style={styles.summaryTitle}


>

Remaining Balance

</Text>



<Text


style={styles.summaryValue}


>

$

{

totalBalance.toFixed(2)

}

</Text>



</View>







</View>







{/*

==========================================================
TRANSACTION TABLE
==========================================================

*/}





<View


style={styles.table}


>






<View


style={styles.tableHeader}


>




<Text

style={[
    styles.cell,
    styles.idCell
]}

>

ID

</Text>






<Text

style={[
    styles.cell,
    styles.studentCell
]}

>

Student

</Text>






<Text

style={[
    styles.cell,
    styles.feeCell
]}

>

Fee Type

</Text>






<Text

style={[
    styles.cell,
    styles.categoryCell
]}

>

Category

</Text>






<Text

style={[
    styles.cell,
    styles.amountCell
]}

>

Paid

</Text>






<Text

style={[
    styles.cell,
    styles.balanceCell
]}

>

Balance

</Text>






<Text

style={[
    styles.cell,
    styles.payerCell
]}

>

Payer

</Text>






<Text

style={[
    styles.cell,
    styles.createdCell
]}

>

Created By

</Text>






<Text

style={[
    styles.cell,
    styles.dateCell
]}

>

Date

</Text>





</View>









{/*

==========================================================
TRANSACTION ROWS
==========================================================

*/}







{

transactions.map(


(item,index)=>(



<View


key={index}


style={styles.tableRow}


wrap={false}


>





<Text

style={[
    styles.cell,
    styles.idCell
]}

>

{

item.id

}

</Text>






<Text

style={[
    styles.cell,
    styles.studentCell
]}

>

{

item.student_name ||

"-"

}

</Text>






<Text

style={[
    styles.cell,
    styles.feeCell
]}

>

{

item.fee_type ||

"-"

}

</Text>






<Text

style={[
    styles.cell,
    styles.categoryCell
]}

>

{

item.payment_category ||

"-"

}

</Text>






<Text

style={[
    styles.cell,
    styles.amountCell
]}

>

$

{

Number(

item.amount_paid || 0

)

.toLocaleString()

}

</Text>






<Text

style={[
    styles.cell,
    styles.balanceCell
]}

>

$

{

Number(

item.balance || 0

)

.toLocaleString()

}

</Text>






<Text

style={[
    styles.cell,
    styles.payerCell
]}

>

{

item.payer_name ||

"-"

}

</Text>






<Text

style={[
    styles.cell,
    styles.createdCell
]}

>

{

item.created_by ||

"-"

}

</Text>






<Text

style={[
    styles.cell,
    styles.dateCell
]}

>

{

item.created_at ||

"-"

}

</Text>





</View>



)



)

}






</View>









{/*

==========================================================
FOOTER
==========================================================

*/}





<Text


style={styles.footer}


fixed


>

Official Payment Transaction Record -

Academic Year Verified - Polu Integrated Technology

</Text>







</Page>





</Document>



);


};







export default DailyPaymentTransactionPDF;